module.exports = __webpack_public_path__ + "img/maestro.e0162458.png";